import React from 'react'
import {
  BooleanInput,
  Edit,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin'
import validateExists from '../../validators/validateExists'
import validateTypebotPublicId from '../../validators/validateTypebotPublicId'
import ImageUploadInput from '../common/ImageUploadInput'

const EditOrganization = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput
        source='name'
        validate={[required(), validateExists(props, 'name')]}
      />
      <ImageUploadInput source='logo_url' label='Logo' />
      <TextInput
        source='typebot_public_id'
        label='Chatbot (Typebot public ID)'
        helperText="Used by merchants that don't set their own"
        validate={validateTypebotPublicId}
      />
      <TextInput source='meta' />
      <BooleanInput source='enable_fleet_integration' />
      <BooleanInput source='allow_chargable_operations' />
    </SimpleForm>
  </Edit>
)

export default EditOrganization
